<template>
  <b-container
    v-if="renderPage"
    fluid
    class="p-0"
  >
    <b-card>
      <div class="d-flex justify-content-center">
        <b-col
          md="11"
          lg="10"
        >
          <b-row class="d-flex justify-content-center">
            <div>
              <icon :type="isSuccess ? 'success' : 'error'" />
            </div>
            <h1 class="text-center title">
              {{ textResponse }}
            </h1>
          </b-row>
          <div v-if="isSuccess">
            <p>
              Link:
            </p>
            <b-card class="card-grey center">
              <a
                class="text-center text-card"
                :href="link"
              >
                {{ link }}
              </a>
            </b-card>
            <b-row>
              <b-col
                md="6"
                lg="4"
                xl="4"
              >
                <b-button
                  :href="link"
                  target="_blank"
                  variant="info"
                  class="button-controllers"
                >
                  Link {{ type === 'payment-link' ? 'do Pagamento' : type === 'recurrence-link' ? 'da Recorrência' : 'do Boleto' }}
                </b-button>
              </b-col>
              <b-col
                md="6"
                lg="4"
                xl="4"
              >
                <b-button
                  variant="info"
                  class="button-controllers"
                  @click="resendMail()"
                >
                  Reenvio de email
                </b-button>
              </b-col>
              <b-col
                md="6"
                lg="4"
                xl="4"
              >
                <b-button
                  variant="info"
                  class="button-controllers"
                  @click="redirect()"
                >
                  Nova Cobrança
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BCard,
  BContainer,
} from 'bootstrap-vue'

import { getLink } from '@/service/transaction-generator/transaction-generator'
import { resendEmail } from '@/service/transaction/transaction'
import { callLoading } from '@/service/utilities/utilities'

import Icon from '@/layouts/components/Icon.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BContainer,
    Icon,
  },
  data() {
    return {
      hash: null,
      link: null,
      isSuccess: false,
      textResponse: null,
      renderPage: false,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  async mounted() {
    callLoading(true)
    this.hash = this.$route.params.hash || this.$route.params.bar_code
    const [, type] = this.$route.path.split('/')
    this.type = type === 'venda-direta' ? 'payment-link' : type === 'recorrencia' ? 'recurrence-link' : 'bankslip'

    if (!this.hash) { this.isSuccess = false }

    await this.checkSuccess()
    callLoading(false)
  },
  methods: {
    async resendMail() {
      try {
        callLoading(true, true)
        const { status } = await resendEmail(this.hash, this.type)
        if (status === 200) { this.emailResponse(true) } else { this.emailResponse(false) }
      } catch (err) {
        this.emailResponse(false)
      } finally {
        callLoading(false)
      }
    },
    emailResponse(isSuccess) {
      if (isSuccess) {
        this.$swal({
          title: 'Email enviado com sucesso',
          icon: 'success',
          timer: 1400,
          showConfirmButton: false,
          buttonsStyling: false,
        })
      } else {
        this.$swal({
          title: 'Não foi possível enviar o email',
          icon: 'error',
          timer: 1400,
          showConfirmButton: false,
          buttonsStyling: false,
        })
      }
    },
    async checkSuccess() {
      try {
        const response = await getLink(this.type, this.hash)
        if (this.type === 'payment-link' || this.type === 'recurrence-link') { this.link = `${process.env.VUE_APP_URL}${this.type === 'payment-link' ? 'link-pagamento' : 'link-recorrencia'}/1/${this.hash}` } else { this.link = response.data.bankslip.url }

        if (response.status === 200) {
          this.isSuccess = true
          this.textResponse = `${this.type === 'payment-link' ? 'Link de Pagamento' : this.type === 'recurrence-link' ? 'Link de Recorrência' : 'Boleto'} gerado com sucesso!`
        } else {
          this.isSuccess = false
          this.textResponse = `Não foi possível gerar ${this.type === 'payment-link' ? 'Link de Pagamento' : this.type === 'recurrence-link' ? 'Link de Recorrência' : 'Boleto'}!`
        }
      } catch (err) {
        this.isSuccess = false
        this.textResponse = `Não foi possível gerar ${this.type === 'payment-link' ? 'Link de Pagamento' : this.type === 'recurrence-link' ? 'Link de Recorrência' : 'Boleto'}!`
      } finally {
        this.renderPage = true
      }
    },
    copy() {
      navigator.clipboard.writeText(this.link)
    },
    redirect() {
      this.$router.push('/novas-cobrancas')
    },
  },
}
</script>

<style scoped lang="scss">
  @import '@core/scss/base/pages/page-link-generator.scss';
</style>
